export default __webpack_public_path__ + "static/media/qt-icon.e168fd1b.svg";